export default function () {
  const blocks = document.querySelectorAll(".view-height-text-block");
  if (blocks.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.7,
    },
  );

  blocks.forEach((block) => observer.observe(block));
}
